// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function coupon_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var coupon_code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "coupon_code"), null));
  if (coupon_code.TAG === /* Ok */0) {
    var discount_amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "discount_amount"), null));
    if (discount_amount.TAG === /* Ok */0) {
      var validity = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "validity"), null));
      if (validity.TAG === /* Ok */0) {
        var expired = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "expired"), null));
        if (expired.TAG === /* Ok */0) {
          var message = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
          if (message.TAG === /* Ok */0) {
            var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
            if (title.TAG === /* Ok */0) {
              var short_description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "short_description"), null));
              if (short_description.TAG === /* Ok */0) {
                var long_description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "long_description"), null));
                if (long_description.TAG === /* Ok */0) {
                  var auto_apply = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "auto_apply"), null));
                  if (auto_apply.TAG === /* Ok */0) {
                    var vehicle_ids = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_ids"), null));
                    if (vehicle_ids.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                coupon_code: coupon_code._0,
                                discount_amount: discount_amount._0,
                                validity: validity._0,
                                expired: expired._0,
                                message: message._0,
                                title: title._0,
                                short_description: short_description._0,
                                long_description: long_description._0,
                                auto_apply: auto_apply._0,
                                vehicle_ids: vehicle_ids._0
                              }
                            };
                    }
                    var e = vehicle_ids._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".vehicle_ids" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = auto_apply._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".auto_apply" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }
                var e$2 = long_description._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".long_description" + e$2.path,
                          message: e$2.message,
                          value: e$2.value
                        }
                      };
              }
              var e$3 = short_description._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".short_description" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = title._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".title" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = message._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".message" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
        }
        var e$6 = expired._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".expired" + e$6.path,
                  message: e$6.message,
                  value: e$6.value
                }
              };
      }
      var e$7 = validity._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".validity" + e$7.path,
                message: e$7.message,
                value: e$7.value
              }
            };
    }
    var e$8 = discount_amount._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".discount_amount" + e$8.path,
              message: e$8.message,
              value: e$8.value
            }
          };
  }
  var e$9 = coupon_code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".coupon_code" + e$9.path,
            message: e$9.message,
            value: e$9.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var offers = Decco.arrayFromJson(coupon_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "offers"), null));
  if (offers.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              offers: offers._0
            }
          };
  }
  var e = offers._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".offers" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  coupon_decode ,
  t_decode ,
  
}
/* No side effect */
